// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
export const attendingPrompt_okay = () => 'attendingPrompt_okay'